<template>
  <p>{{ item.zip }} <span>{{ item.name }}</span></p>
</template>

<style type="text/css">
	.v-autocomplete .v-autocomplete-list p {
		cursor: pointer;
	}
	.v-autocomplete .v-autocomplete-list p span {
		font-weight: bold;
	}
</style>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script>